// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__19s5o","name":"ConsentHeader_name__YGRKj","birthday":"ConsentHeader_birthday__2lT_M","skeleton":"ConsentHeader_skeleton__3iiCm"};